import { useEffect, useState } from 'react';

let verboseModeEnabled = false;
let hookSubscriptions: ((enabled: boolean) => void)[] = [];

export function useLayoutVerboseMode(): boolean {
  const [isEnabled, setIsEnabled] = useState(verboseModeEnabled);

  useEffect(() => {
    hookSubscriptions.push(setIsEnabled);
    return () => void (hookSubscriptions = hookSubscriptions.filter((listener) => listener !== setIsEnabled));
  }, [setIsEnabled]);

  return isEnabled;
}

function setLayoutVerboseMode(enabled: boolean) {
  verboseModeEnabled = enabled;
  hookSubscriptions.forEach((listener) => listener(enabled));
}

if (process.env.APP_ENV !== 'production') {
  (globalThis as unknown as any).setLayoutVerboseMode = setLayoutVerboseMode;
}
